import { toast, ToasterProps } from 'sonner';

import { UiCartToastAdded } from './UiCartToastAdded';

interface ToastCardAddedParams {
  src: string;
  subtitle: string;
  tabs: string[];
  position?: ToasterProps['position'];
  openInNewTab?: boolean;
}

export const toastCartAdded = ({
  src,
  subtitle,
  tabs,
  position = 'top-right',
  openInNewTab = false
}: ToastCardAddedParams) => {
  toast.custom(
    () => (
      <div
        style={{ pointerEvents: 'auto' }}
        onClick={() => {
          toast.dismiss();
        }}
      >
        <UiCartToastAdded
          src={src}
          subtitle={subtitle}
          tabs={tabs}
          openInNewTab={openInNewTab}
        />
      </div>
    ),
    { position }
  );
};
